(function(){
    angular
        .module('appback')
        .directive('ngLipidograma063', lipidograma063);

        lipidograma063.$inject = ['ResultadosService','$timeout'];
        function lipidograma063(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=lipidograma063.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  sub: '=',
                  centro:'='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	scope.subanaliticas = [];
		            	ResultadosService.getSubanaliticasByAnalitica(scope.item.analitica_id,scope.animal.especie_id,scope.centro.idioma_code,function(data){
			               scope.subanaliticas = data.subanaliticas;
			               scope.sumaPorcentaje();
			            });

			            if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : { subanaliticas : [{}] }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { subanaliticas : [{}] }};
				            }
				        }

		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                    }

	                    scope.sumaPorcentaje = function(){
	                    	var suma = 0;
	                    	//console.log(scope.item.resultado.extra.resultado.subanalitica);
	                    	for(var cont = 0;cont<scope.subanaliticas.length;cont++){
	                    		if(scope.subanaliticas[cont].codigo_alfa!='LIPT' && typeof(scope.item.resultado.extra.resultado.subanalitica)!='undefined'){
	                    			if(typeof(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa])!='undefined' && !isNaN(parseFloat(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].resultado_porcentaje))){
		                    			suma+=parseFloat(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].resultado_porcentaje);
		                    			scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].resultado = ((scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].resultado_porcentaje * scope.item.resultado.extra.resultado.totales_resultado) /100).toFixed(2);
		                    		}
	                    		}
	                    	}
	                    	if(typeof(scope.item.resultado.extra.resultado.subanalitica)!='undefined'){
		                    	if(scope.item.resultado.extra.resultado.subanalitica['LIPT']){
			                    	scope.item.resultado.extra.resultado.subanalitica['LIPT'].resultado_porcentaje = suma.toFixed(2);
			                    }else{
			                    	scope.item.resultado.extra.resultado.subanalitica['LIPT'] = {resultado_porcentaje : suma.toFixed(2)};

			                    }
			                }
	                    }

			        });
		        }
          }
      }
})();